import React, { useEffect, useState, useRef, useContext } from 'react';
import { Link, useNavigate, useParams  } from "react-router-dom";
import Layout from '../../parts/Layout';
import helpers from '../../../services/helpers';
import { httpRequest } from '../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import store from '../../../services/store';
// import InputText from '../../elements/InputText';
// import InputTextArea from '../../elements/InputTextArea';
import RenderErrors from '../../elements/RenderErrors';
import ContactListModal from '../../modals/ContactListModal';
import AddressBookModal from '../../modals/AddressBookModal';
import ProductFinderModal from '../../modals/ProductFinderModal';
import ProductLookup from '../../modals/ProductLookup';
import PaymentsListModal from '../../modals/PaymentsListModal';
import initTreeView from '../../../services/initTreeView';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
// import Button from 'react-bootstrap/Button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { SplitButton } from 'primereact/splitbutton';
import { SelectButton } from 'primereact/selectbutton';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import ButtonGroupSelection from '../../elements/ButtonGroupSelection';
import { InputTextarea } from 'primereact/inputtextarea';
import ProfileContext from '../../../services/profileContext';

import TaxRateFormModal from '../../modals/TaxRateFormModal';
import DiscountRateFormModal from '../discount-rates/DiscountRateFormModal';

export default function QuotationForm (){
    const {
        account
    } = useContext(ProfileContext);
    const default_currency = helpers.getSettingValue(account?.settings, 'default_currency', '₱');
    const tax_enabled = helpers.getSettingValue(account?.settings, 'tax_enabled', 1);
    const discount_enabled = helpers.getSettingValue(account?.settings, 'discount_enabled', 1);
    const single_label = helpers.getSettingValue(account?.settings, 'quotation_single_label', 'Quotation');
    const plural_label = helpers.getSettingValue(account?.settings, 'quotation_plural_label', 'Quotations');
    const heading_label = `Manage ${plural_label}`;
    const add_label = `New ${single_label}`;
    const edit_label = `Edit ${single_label}`;
    
    const { quotation_id } = useParams();
    const [loading, setLoading] = useState(1);
    const navigate = useNavigate();
    const [errors, setErrors] = useState([]);
    const [page_title, setPageTitle] = useState(add_label);
    const [record_loaded, setRecordLoaded] = useState(0);
    const [form_data, setFormData] = useState(store.quotation_data);
    const [record_items, setRecordItems] = useState([]);
    const [table_items, setTableItems] = useState([]);
    const [enums, setEnums] = useState(store.order_enums);
    const [customer_modal, setContactModal] = useState(0);
    const [address_modal, setAddressModal] = useState(0);
    const [address_type, setAddressType] = useState('');
    const [product_modal, setProductModal] = useState(0);
    const [same_address, setSameAddress] = useState(0);
    const [payments_modal, setPaymentsModal] = useState(false);
    const [tax_breakdown, setTaxBreakdown] = useState([]);
    const [button_items, setButtonItems] = useState([]);

    const dropdownRef = useRef(null);
    const [show_tax_modal, setShowTaxModal] = useState(0);
    const [show_discount_modal, setShowDiscountModal] = useState(0);
    const [discount_breakdown, setDiscountBreakdown] = useState([]);
    const [is_customer, setIsCustomer] = useState(false);
    const [is_disable, setDisable] = useState(false);

    useEffect(() => {
        initTreeView()

        if(quotation_id){
            setPageTitle(edit_label)
            fetchData(quotation_id)
        }
        else{
            setButtonItems([{
                label: 'Save and Confirm',
                icon: 'pi pi-refresh',
                command: (e) => {
                    submit(e.originalEvent, 2)
                }
            }])
            getEnums()
        }

        if(account?.user.type === 'customer'){
            setIsCustomer(true)
        }
    }, []);

    useEffect(() => {
        if(is_customer){
            const user_data = account?.user

            let data = {...form_data}
            data.customer_id = user_data?.linked_id
            data.customer_name = user_data?.linked_data?.contact_name
            data.payment_term_id = 1

            setFormData(data)

            if(!quotation_id){
                fetchCustomer(user_data?.linked_id)
            }
        }
    }, [is_customer]);

    useEffect(() => {
        displayTableItems()
        computeTotals();
        showTaxBreakdown()
        showDiscountBreakdown()
    }, [record_items]);

    useEffect(() => {
        if(form_data.quotation_status_id == 1){
            setButtonItems([{
                label: 'Save as Open',
                icon: 'pi pi-refresh',
                command: (e) => {
                    submit(e.originalEvent, 1)
                }
            }])
        }
        else{
            setButtonItems([{
                label: 'Save as Open',
                icon: 'pi pi-refresh',
                command: (e) => {
                    //setLoading(1)
                    //updateStatusItem(quotation_id, 1)
                    submit(e.originalEvent, 1)
                }
            }])
        }
    }, [form_data, record_items]);

    useEffect(() => {
        displayTableItems()
        //showTaxBreakdown()
    }, [enums]);

    function fetchData(quotation_id){
        if(!quotation_id){
            return
        }
        const url = helpers.createUrl('V1/manage/quotations/'+quotation_id+'?store_id='+helpers.getStoreID())
        
        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            let data = res;
            data.quotation_date = new Date(res.quotation_date)
            //items.due_date = new Date(res.due_date)

            console.log('data', data)

            setLoading(0)
            setFormData(data)
            setRecordItems(data.items)
            getEnums()
            setRecordLoaded(1)

            let btn_item = []
            if(res.quotation_status_id === 1){
                btn_item.push({
                    label: 'Save and Confirm',
                    icon: 'pi pi-refresh',
                    command: (e) => {
                        submit(e.originalEvent, 2)
                    }
                })
            }
            else if(res.quotation_status_id === 2){
                btn_item.push({
                    label: 'Set as Open',
                    icon: 'pi pi-refresh',
                    command: (e) => {
                        submit(e.originalEvent, 1)
                    }
                })
            }

            setButtonItems(btn_item)
        })
        .catch((err) => {
            setLoading(0)
            getEnums()

            Swal.fire({
                //title: err.message,
                text: err.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    //return navigate("/item/list");
                    window.location.replace("/quotations/list");
                }
            })
        }); 

    }

    function fetchCustomer(contact_id){
        if(!contact_id){
            return
        }
        const url = helpers.createUrl(`V1/manage/contact/${contact_id}?store_id=${helpers.getStoreID()}`)

        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {

            const address = res?.address

            const billing_address = helpers.filterObject(address, [3, 1], 'address_type_id')
            const shipping_address = helpers.filterObject(address, [3, 2], 'address_type_id')
        
            let updated_data = {
                billing_address_id : billing_address?.[0]?.id ?? '',
                billing_address : billing_address?.[0]?.address ?? '',
                billing_phone : billing_address?.[0]?.phone_no ?? '',
                billing_email : billing_address?.[0]?.email ?? '',
                billing_state : billing_address?.[0]?.state ?? '',
                billing_city : billing_address?.[0]?.city ?? '',
                billing_barangay : billing_address?.[0]?.barangay ?? '',

                shipping_address_id : shipping_address?.[0]?.id ?? '',
                shipping_address : shipping_address?.[0]?.address ?? '',
                shipping_contact_name : shipping_address?.[0]?.contact_name ?? '',
                shipping_phone : shipping_address?.[0]?.phone_no ?? '',
                shipping_state : shipping_address?.[0]?.state ?? '',
                shipping_city : shipping_address?.[0]?.city ?? '',
                shipping_barangay : shipping_address?.[0]?.barangay ?? ''
            }

            //console.log('billing_address', billing_address)
            //console.log('shipping_address', shipping_address)
                setFormData(prev => ({
                    ...prev,
                    ...updated_data
                }))
        })
        .catch((err) => {
            setLoading(0)

            Swal.fire({
                //title: err.message,
                text: err.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
        }); 
    }

    function getEnums(){
        setLoading(1)

        const url = helpers.createUrl(`V1/enums/orders?store_id=${helpers.getStoreID()}`)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            setEnums(res)
            setLoading(0)
        })
        .catch((err) => {
            setLoading(0)
        }); 
    }

    // function showTaxBreakdown(){
    //     let taxes = [];
    //     let total_tax = 0

    //     if (record_items.length) {
    //         Object.entries(record_items).map(([key, data]) => {
    //             console.log('data', data)

    //             if(!data.tax_rate && !data.tax_name) return;

    //             const tax = taxes.find(item => item.name == data.tax_name && parseFloat(data.tax_rate))
    //             if(!tax){
    //                 taxes.push({
    //                     "name": data.tax_name,
    //                     "display": `${data.tax_name} (${data.tax_rate}%)`,
    //                     "rate": parseFloat(data.tax_rate),
    //                     "total": parseFloat(data.tax_amount)
    //                 })

    //                 total_tax = total_tax + parseFloat(data.tax_amount)
    //             }
    //             else{
    //                 const tax_i = taxes.findIndex(item => item.name == data.tax_name && parseFloat(data.tax_rate))
    //                 let target = {...taxes[tax_i]}

    //                 let compute_tax = parseFloat(target.total) + parseFloat(data.tax_amount)
    //                 total_tax = total_tax + compute_tax

    //                 target['total'] = compute_tax
    //                 taxes[tax_i] = target
    //             }
    //         })
    //     }

    //     let breakdown = []
    //     if(taxes.length){
    //         total_tax = taxes.reduce((sum, tax) => sum + (parseFloat(tax.total) || 0), 0);

    //         let i = 1;
    //         breakdown = Object.entries(taxes).map(([key, data]) => {
    //             let td_class = 'border-0 pt-0'
    //             if(i == 1){
    //                 td_class = ''
    //             }
    //             i++;
                
    //             return (
    //                 <tr>
    //                     <td className={`text-right ${td_class}`}>{data.display}</td>
    //                     <td className={`${td_class}`}>{helpers.formatCurrencyAmount(data.total, default_currency)}</td>
    //                 </tr>
    //             )
    //         })

    //         breakdown.push(
    //                     <tr>
    //                         <td className="border-0 pt-0 text-right"><b>Total Tax</b></td>
    //                         <td className='border-0 pt-0'><b className='border-top pt-2'>{helpers.formatCurrencyAmount(total_tax, default_currency)}</b></td>
    //                     </tr>
    //         )
    //     }

    //     setTaxBreakdown(breakdown)
    // }

    function showTaxBreakdown(){
        const taxesMap = new Map();

        record_items.forEach((item) => {
            const { tax_name, tax_rate, tax_amount } = item;

            if (!tax_name || !tax_rate) return;

            const key = `${tax_name}_${tax_rate}`;
            const rate = parseFloat(tax_rate);
            const amount = parseFloat(tax_amount) || 0;

            if (!taxesMap.has(key)) {
                taxesMap.set(key, {
                name: tax_name,
                display: `${tax_name} (${rate}%)`,
                rate,
                total: amount,
                });
            } else {
                const existing = taxesMap.get(key);
                existing.total += amount;
                taxesMap.set(key, existing);
            }
        });

        const taxes = Array.from(taxesMap.values());
        const totalTax = taxes.reduce((sum, tax) => sum + (parseFloat(tax.total) || 0), 0);

        const breakdown = taxes.map((tax, index) => {
            const tdClass = index === 0 ? '' : 'border-0 pt-0';
            
            return (
                <tr key={tax.name + tax.rate}>
                <td className={`text-right ${tdClass}`}>{tax.display}</td>
                <td className={tdClass}>{helpers.formatCurrencyAmount(tax.total, default_currency)}</td>
                </tr>
            );
        });

        if(breakdown.length){
            breakdown.push(
                <tr key="total-tax">
                    <td className="border-0 pt-0 text-right"><b>Total Tax</b></td>
                    <td className="border-0 pt-0">
                    <b className="border-top pt-2">{helpers.formatCurrencyAmount(totalTax, default_currency)}</b>
                    </td>
                </tr>
            );
        }

        setTaxBreakdown(breakdown);
    }

    function showDiscountBreakdown(){
        const discountsMap = new Map();

        record_items.forEach((item) => {
            const { discount_name, discount_type, discount_rate, discount_amount } = item;

            if (!discount_name || !discount_rate) return;

            const key = `${discount_name}_${discount_rate}`;
            const rate = parseFloat(discount_rate);
            const amount = parseFloat(discount_amount) || 0;

            if (!discountsMap.has(key)) {
                let display = `${discount_name} (${rate}%)`
                
                if(discount_type === 'fixed-rate'){
                    display = `${discount_name} (${default_currency}${'\u00A0'}${rate})`
                }

                discountsMap.set(key, {
                name: discount_name,
                display: display,
                rate,
                total: amount,
                });
            } else {
                const existing = discountsMap.get(key);
                existing.total += amount;
                discountsMap.set(key, existing);
            }
        });

        const discounts = Array.from(discountsMap.values());
        const totalDiscount = discounts.reduce((sum, discount) => sum + (parseFloat(discount.total) || 0), 0);

        const breakdown = discounts.map((discount, index) => {
            const tdClass = index === 0 ? '' : 'border-0 pt-0';
            
            return (
                <tr key={discount.name + discount.rate}>
                <td className={`text-right ${tdClass}`}>{discount.display}</td>
                <td className={tdClass}>{helpers.formatCurrencyAmount(discount.total, default_currency)}</td>
                </tr>
            );
        });

        if(breakdown.length){
            breakdown.push(
                <tr key="total-discount">
                    <td className="border-0 pt-0 text-right"><b>Total Discount</b></td>
                    <td className="border-0 pt-0">
                    <b className="border-top pt-2">{helpers.formatCurrencyAmount(totalDiscount, default_currency)}</b>
                    </td>
                </tr>
            );
        }

        setDiscountBreakdown(breakdown);
    }

    function computeSubTotals(){
        let items = 0;
        let total_amount = 0

        record_items.forEach((data) => {
            const quantity = parseInt(data.quantity ?? '0', 10);
            const price = parseFloat(data.amount ?? '0');
            const discount = parseFloat(data.discount_amount ?? '0');

            const totalPrice = price * quantity
            const netPrice = totalPrice - discount;

            items += quantity;
            total_amount += netPrice
        });

        return helpers.formatCurrencyAmount(total_amount, default_currency);
    }

    function computeTotals(type){
        let items = 0;
        let total_amount = 0

        record_items.forEach((data) => {
            const quantity = parseInt(data.quantity ?? '0', 10);
            const price = parseFloat(data.amount ?? '0');
            const discount = parseFloat(data.discount_amount ?? '0');
            const tax_amount = parseFloat(data.tax_amount ?? '0');

            const totalPrice = price * quantity
            const netPrice = totalPrice - discount;

            items += quantity;
            total_amount += netPrice + tax_amount
        });
        // Object.entries(record_items).map(([key, data]) => {
        //    // const amount = data.amount ?? 0;
        //     const amount = data.amount ?? data.amount

        //     const tax_amount = data.tax_amount ?? 0;
        //     const quantity = data.quantity ?? 0
        //     items = items + Number(quantity)

        //     total_amount = total_amount + (parseInt(quantity) * parseFloat(amount) + parseFloat(tax_amount))
        // });

        const shipping_fee = form_data.shipping_fee ?? 0;
        total_amount += parseFloat(shipping_fee)

        if(type == 'quantity'){
            return items;
        }

        if(type == 'total'){
            return helpers.formatAmount(total_amount);
        }

    }

    function displayTableItems(){
        let items = []
        
        if (record_items.length) {
            items = Object.entries(record_items).map(([key, data]) => {
                const trackInventory = parseInt(data?.track_inventory ?? '0', 10);
                const quantity = parseInt(data?.quantity ?? '0', 10)
                const unitPrice = parseFloat(data?.amount ?? '0');
                const discountAmount = parseFloat(data?.discount_amount ?? '0');

                // let total = parseInt(data.quantity) * parseFloat(data.amount)
                let total = quantity * unitPrice;
                if (!isNaN(discountAmount) && discountAmount > 0) {
                    total = Math.max(0, total - discountAmount); // prevent negative total
                }

                total = <>{helpers.formatCurrencyAmount(total, default_currency)}</>
                return(
                <tr>
                    <td width={500}>
                        <span>{data.product_name}{data.product_variant_name != 'Generic' ? ` (${data.product_variant_name})` : '' }</span><br/>
                        <small>SKU: {data.product_code}</small><br/>
                        {/* <small>{data.product_type_id == 1 ? 'Goods' : 'Service'}</small> */}
                        
                        {
                            !is_customer && 
                            <InputTextarea
                                name="product_description" 
                                value={data.product_description}  
                                className="w-100 mt-2 p-1"
                                maxLength={1500}
                                onChange={(e) => inputItemChange(e, key)}
                                placeholder="Description"
                                readOnly={form_data.quotation_status_id == 3 || form_data.quotation_status_id == 4}
                            />
                        }
                    </td>
                    <td width={250}>
                        {
                            (parseInt(form_data.quotation_status_id) === 1 || parseInt(form_data.quotation_status_id) === 5) || (parseInt(form_data.quotation_status_id) === 2 && !is_customer)
                            ?
                            <>
                            <InputNumber
                                id="quantity" 
                                name="quantity" 
                                className="quantity-input"
                                inputStyle={{ minWidth: '50px' }}
                                value={data.quantity}
                                tagClass="mb-0"
                                onValueChange={(e) => inputItemChange(e, key)}
                                placeholder="Qty"
                                min={data.fulfilled_quantity ?? 0}
                                max={trackInventory ? data.available_stock : 999999}
                                showButtons
                                buttonLayout="horizontal"
                                inputClassName="rounded-0"
                                decrementButtonClassName="p-input-button-left" 
                                incrementButtonClassName="p-input-button-right" 
                                incrementButtonIcon="fas fa-plus" 
                                decrementButtonIcon="fas fa-minus"
                                disabled={form_data.quotation_status_id == 3 || form_data.quotation_status_id == 4 || (is_customer && form_data.quotation_status_id === 2)}
                            />
                            <br/>
                            </>: 
                            <>{data.quantity}&nbsp;</>
                        }
                        {data.unit_name}
                    </td>
                    <td width={180}>
                        {
                            (parseInt(form_data.quotation_status_id) === 1 || parseInt(form_data.quotation_status_id) === 5) || (parseInt(form_data.quotation_status_id) === 2 && !is_customer)
                            ?
                            <InputNumber
                                id="amount" 
                                name="amount" 
                                value={data.amount}
                                inputClassName="w-100"
                                onValueChange={(e) => inputItemChange(e, key)}
                                placeholder="Price"
                                minFractionDigits={2}
                                readOnly={form_data.quotation_status_id == 3 || form_data.quotation_status_id == 4 || is_customer}
                            />
                            :
                            helpers.formatCurrencyAmount(data.amount, default_currency)
                        }
                    </td>
                    
                    {parseInt(discount_enabled) && !is_customer ?
                    <td width={250}>
                        {
                            (parseInt(form_data.quotation_status_id) === 1 || parseInt(form_data.quotation_status_id) === 5) || parseInt(form_data.quotation_status_id) === 2
                            ?
                            <Dropdown  
                                ref={dropdownRef}
                                name='discount_rate'
                                value={parseInt(data.discount_rate_id)} 
                                onChange={(e) => inputItemChange(e, key)}
                                options={enums.discount_rates} 
                                optionLabel="label" 
                                optionValue="id" 
                                placeholder="Select Discount Rate" 
                                checkmark={true} 
                                highlightOnSelect={false}
                                showClear
                                filter 
                                disabled={form_data.quotation_status_id == 3 || form_data.quotation_status_id == 4}
                                className='w-100'
                                panelFooterTemplate={footerTemplateDiscount}
                            /> :
                            <div>{parseFloat(data.discount_amount) ? <>{helpers.formatCurrencyAmount(data.discount_amount, default_currency)}<br/>[{data.discount_name} {data.discount_rate}]</>  : ''}</div>
                        }

                        {
                            parseInt(form_data.quotation_status_id) === 1 || parseInt(form_data.quotation_status_id) === 2 || parseInt(form_data.quotation_status_id) === 5
                            ?
                            <div className='mt-2'>{parseFloat(data.discount_amount) ? helpers.formatCurrencyAmount(data.discount_amount, default_currency) : ''}</div> : ''
                        }
                    </td> : ''}

                    {parseInt(tax_enabled) && !is_customer ?
                    <td width={250}>
                        {
                            parseInt(form_data.quotation_status_id) === 1 || parseInt(form_data.quotation_status_id) === 2 || parseInt(form_data.quotation_status_id) === 5
                            ?
                            <Dropdown  
                                ref={dropdownRef}
                                name='tax_rate'
                                value={parseInt(data.tax_rate_id)} 
                                onChange={(e) => inputItemChange(e, key)}
                                options={enums.tax_rates} 
                                optionLabel="label" 
                                optionValue="id" 
                                placeholder="Select Tax Rate" 
                                checkmark={true} 
                                highlightOnSelect={false}
                                showClear
                                filter 
                                disabled={form_data.quotation_status_id == 3 || form_data.quotation_status_id == 4}
                                className='w-100'
                                panelFooterTemplate={footerTemplateTax}
                            />:
                            <div>{parseFloat(data.tax_amount) ? <>{helpers.formatCurrencyAmount(data.tax_amount, default_currency)}<br/>[{data.tax_name} {data.tax_rate}%]</>  : ''}</div>
                        }

                        {
                            parseInt(form_data.quotation_status_id) === 1 || parseInt(form_data.quotation_status_id) === 2 || parseInt(form_data.quotation_status_id) === 5
                            ?
                            <div className='mt-2'>{parseFloat(data.tax_amount) ? helpers.formatCurrencyAmount(data.tax_amount, default_currency) : ''}</div> : ''
                        }
                    </td> : ''}

                    <td width={180} style={{paddingRight: '.75rem'}}>
                        {showRemoveItem(key, data, is_customer)}
                        <div className='d-flex align-items-center'>
                        {total}
                        </div>
                    </td>
                </tr>)

            })
        }

        setTableItems(items)
    }

    function showRemoveItem(key, data, is_customer){
        if(is_customer && form_data.quotation_status_id !== 1){
           // console.log('customer and status is 1')
            return
        }
        else if(parseInt(form_data.quotation_status_id) !== 1 && parseInt(form_data.quotation_status_id) !== 2){
            //console.log('status must no 1 or 2')
            return
        }
        else if(data.fulfilled_quantity){
            //console.log('has fulfilled quantity')
            return
        }
        
        return <button type="button"className='btn p-0 pointer float-right ml-2 mt-5 mt-lg-0' onClick={(e) => removeItem(key)} title='Remove Item'><i className="fa fa-trash-alt text-danger"></i></button>

        // {
        //     (parseInt(form_data.quotation_status_id) === 1 || parseInt(form_data.quotation_status_id) === 2) && !data.fulfilled_quantity && (!is_customer && form_data.quotation_status_id === 1) ? 
        //     <button className='btn btn-sm text-muted float-right' type="button" onClick={(e) => removeItem(key)}><i className="fas fa-times text-danger"></i></button>: ''
        // }
    }

    function removeItem(key){
        let items = [...record_items]
        items.splice(key, 1); 

        setRecordItems(items)
    }
    
    function inputChange(e) {
        let { value, name } = e.target;

        if(name == 'same_address'){
            if (e.target.checked) {
                value = 1;
            } else {
                value = 0;
            }
            let data = {...form_data}
            data.shipping_address_id = ''
            data.shipping_address = ''
            data.shipping_contact_name = ''
            //data.shipping_phone = ''

            if(value){
                data.shipping_address_id = data.billing_address_id
                data.shipping_address = data.billing_address
                data.shipping_contact_name = data.customer_name
                //data.shipping_phone = ''
            }
                
            setFormData(data)

            setSameAddress(value)
            return;
        }

        if (e.target.type === "checkbox") {
            if (e.target.checked) {
                value = 1;

                if(name == 'warranty_status') value = 'active'
            } else {
                value = 0;

                if(name == 'warranty_status') value = 'expired'
            }
        }
        else if (e.target.type === "file") {
          value = e.target.files[0]
        }

        let new_state = { [name]: value }

        if(same_address && name == 'customer_name'){
            new_state.shipping_contact_name = value
        }

        setFormData({ ...form_data, ...new_state });
    }
    
    function inputItemChange(e, key) {
        //let { name, value } = e.target;

        let { name, type, value: rawValue, checked, files } = e.target;
        let value = rawValue ?? '';

        let items = [...record_items]
        let target = {...items[key]}

        if(name === 'quantity'){
            const track_inventory = parseInt(target?.track_inventory ?? 1)
            const available_stock = target['available_stock']

            if(track_inventory && (parseInt(value) > parseInt(available_stock))){
                return;
            }
            
            let price = parseFloat(target.amount);
            const quantity = parseInt(value);
            let totalPrice = price * quantity;
            
            /**
             * Compute first the discount if existed
             */
            const discount_rate_id = parseInt(target?.discount_rate_id ?? '0')
            const discount = helpers.filterObject(enums.discount_rates, discount_rate_id) ?? null;
            if (discount?.id) {
                const { discount_type, discount_rate } = discount;
                const rate = parseFloat(discount_rate);
                let unitDiscount = 0;

                if (discount_type === 'percentage') {
                    const normalizedRate = rate > 1 ? rate / 100 : rate;
                    unitDiscount = price * normalizedRate;
                } else if (discount_type === 'fixed-rate') {
                    unitDiscount = Math.min(rate, price); // prevent negative price
                }

                const unitPrice = price - unitDiscount;
                const totalDiscount = unitDiscount * quantity;
                totalPrice = unitPrice * quantity;

                Object.assign(target, {
                    discount_amount: totalDiscount,
                });
            }

            const tax_rate_id = parseInt(target?.tax_rate_id ?? '0')
            const tax = helpers.filterObject(enums.tax_rates, tax_rate_id) ?? null;
            if (tax?.id) {
                const taxRate = parseFloat(tax.tax_rate);
                const taxAmount = (taxRate / 100) * totalPrice;

                Object.assign(target, {
                    tax_amount: isNaN(taxAmount) ? 0 : taxAmount,
                });
            }
        }
        else if(name === 'tax_rate'){
            name = 'tax_rate_id'
            // const tax = helpers.filterObject(enums.tax_rates, value) ?? [];
            
            // if ( tax.hasOwnProperty('id') ) {
            //     target.tax_name = tax.tax_name
            //     target.tax_rate = tax.tax_rate

            //     const tax_amount = (parseFloat(tax.tax_rate) / 100) * (parseFloat(target.amount) * parseFloat(target.quantity))

            //     if(!isNaN(tax_amount)){
            //         target.tax_amount = tax_amount;
            //     }
            // }
            // else{
            //     target.tax_name = ''
            //     target.tax_rate = ''
            //     target.tax_amount = 0;
            // }
            let price = parseFloat(target.amount);
            const quantity = parseInt(target.quantity);
            let totalPrice = price * quantity;
            
            /**
             * Compute first the discount if existed
             */
            const discount_rate_id = parseInt(target?.discount_rate_id ?? '0')
            const discount = helpers.filterObject(enums.discount_rates, discount_rate_id) ?? null;
            if (discount?.id) {
                const { discount_type, discount_rate } = discount;
                const rate = parseFloat(discount_rate);
                let unitDiscount = 0;

                if (discount_type === 'percentage') {
                    const normalizedRate = rate > 1 ? rate / 100 : rate;
                    unitDiscount = price * normalizedRate;
                } else if (discount_type === 'fixed-rate') {
                    unitDiscount = Math.min(rate, price); // prevent negative price
                }

                const unitPrice = price - unitDiscount;
                totalPrice = unitPrice * quantity;
            }

            const tax = helpers.filterObject(enums.tax_rates, value) ?? null;
            if (tax?.id) {
                const taxRate = parseFloat(tax.tax_rate);
                const taxAmount = (taxRate / 100) * totalPrice;

                Object.assign(target, {
                    tax_name: tax.tax_name,
                    tax_rate: tax.tax_rate,
                    tax_amount: isNaN(taxAmount) ? 0 : taxAmount,
                });
            } else {
                Object.assign(target, {
                    tax_rate_id: '',
                    tax_name: '',
                    tax_rate: '',
                    tax_amount: 0,
                });
            }
        }
        else if(name === 'discount_rate'){
            name = 'discount_rate_id'
            const price = parseFloat(target.amount);
            const quantity = parseInt(target.quantity);
            let totalPrice = price * quantity;
            const discount = helpers.filterObject(enums.discount_rates, value) ?? null;

            if (discount?.id) {
                const { discount_type, discount_name, discount_rate } = discount;
                const rate = parseFloat(discount_rate);
                let unitDiscount = 0;

                if (discount_type === 'percentage') {
                    const normalizedRate = rate > 1 ? rate / 100 : rate;
                    unitDiscount = price * normalizedRate;
                } else if (discount_type === 'fixed-rate') {
                    unitDiscount = Math.min(rate, price); // prevent negative price
                }

                const unitPrice = price - unitDiscount;
                const totalDiscount = unitDiscount * quantity;
                totalPrice = unitPrice * quantity;

                Object.assign(target, {
                    discount_type,
                    discount_name,
                    discount_rate,
                    discount_amount: totalDiscount,
                });
            } else {
                Object.assign(target, {
                    discount_type: '',
                    discount_name: '',
                    discount_rate: '',
                    discount_amount: 0,
                });
            }

            const tax_rate_id = parseInt(target?.tax_rate_id ?? '0')
            const tax = helpers.filterObject(enums.tax_rates, tax_rate_id) ?? null;
            if (tax?.id) {
                const taxRate = parseFloat(tax.tax_rate);
                const taxAmount = (taxRate / 100) * totalPrice;

                Object.assign(target, {
                    tax_amount: isNaN(taxAmount) ? 0 : taxAmount,
                });
            }
        }
        else if(name === 'amount'){
            // if(target.tax_rate){
            //     //const tax_amount = (parseFloat(target.tax_rate) / 100) * parseFloat(value)
            //     const tax_amount = (parseFloat(target.tax_rate) / 100) * (parseFloat(value) * parseFloat(target.quantity))

            //     target.tax_amount = tax_amount
            // }
            
            let price = parseFloat(value);
            const quantity = parseInt(target.quantity);
            let totalPrice = price * quantity;
            
            /**
             * Compute first the discount if existed
             */
            const discount_rate_id = parseInt(target?.discount_rate_id ?? '0')
            const discount = helpers.filterObject(enums.discount_rates, discount_rate_id) ?? null;
            if (discount?.id) {
                const { discount_type, discount_rate } = discount;
                const rate = parseFloat(discount_rate);
                let unitDiscount = 0;

                if (discount_type === 'percentage') {
                    const normalizedRate = rate > 1 ? rate / 100 : rate;
                    unitDiscount = price * normalizedRate;
                } else if (discount_type === 'fixed-rate') {
                    unitDiscount = Math.min(rate, price); // prevent negative price
                }

                const unitPrice = price - unitDiscount;
                const totalDiscount = unitDiscount * quantity;
                totalPrice = unitPrice * quantity;

                Object.assign(target, {
                    discount_amount: totalDiscount,
                });
            }

            const tax_rate_id = parseInt(target?.tax_rate_id ?? '0')
            const tax = helpers.filterObject(enums.tax_rates, tax_rate_id) ?? null;
            if (tax?.id) {
                const taxRate = parseFloat(tax.tax_rate);
                const taxAmount = (taxRate / 100) * totalPrice;

                Object.assign(target, {
                    tax_amount: isNaN(taxAmount) ? 0 : taxAmount,
                });
            } 
        }

        target[name] = value
        items[key] = target

        setRecordItems(items)
    }

    function handleCustomer(e){
        let data = {...form_data}

        const address = e.address
        const billing_address = helpers.filterObject(address, [3, 1], 'address_type_id')
        const shipping_address = helpers.filterObject(address, [3, 2], 'address_type_id')

        data.customer_id = e.id ?? ''
        data.customer_name = e.contact_name ?? ''
        data.billing_address_id = billing_address?.[0]?.id ?? ''
        data.billing_address = billing_address?.[0]?.address ?? ''
        data.billing_phone = billing_address?.[0]?.phone_no ?? ''
        data.billing_email = billing_address?.[0]?.email ?? ''
        data.billing_state = billing_address?.[0]?.state ?? ''
        data.billing_city = billing_address?.[0]?.city ?? ''
        data.billing_barangay = billing_address?.[0]?.barangay ?? ''

        data.shipping_address_id = shipping_address?.[0]?.id ?? ''
        data.shipping_address = shipping_address?.[0]?.address ?? ''
        data.shipping_contact_name = shipping_address?.[0]?.contact_name ?? e.contact_name
        data.shipping_phone = shipping_address?.[0]?.phone_no ?? ''
        data.shipping_state = shipping_address?.[0]?.state ?? ''
        data.shipping_city = shipping_address?.[0]?.city ?? ''
        data.shipping_barangay = shipping_address?.[0]?.barangay ?? ''

        //setCustomer(e)
        setFormData(data)
    }

    function viewAddressBook(type = ''){
        // 1 = Shipping / 2 = Billing
        setAddressType(type)
        setAddressModal(1)
    }

    function handleAddress(e){
        let data = {...form_data}

        if(address_type == 1){//Shipping
            data.shipping_address_id = e.id ?? ''
            data.shipping_address = e.address
            data.shipping_contact_name = e.contact_name
            data.shipping_phone = e.phone_no
        }
        else if(address_type == 2){//Billing
            data.billing_address_id = e.id ?? ''
            data.billing_address = e.address
            data.billing_contact_name = e.contact_name
            data.billing_phone = e.phone_no
        }
        
        setFormData(data)
        //setAddress(e)
    }

    function handleProduct(e){
        let items = [...record_items]

        const description = `${e.product_description ?? ''}${
                                                                e.warranty_details ? `\n\nWarranty:\n${e.warranty_details}` : ''
                                                            }`;

        let new_item = {
            "id": 0,
            "product_id": e.id,
            "product_variant_id": e.product_variant_id,
            "product_type_id": e.product_type_id,
            "quantity": 1,
            "amount": e.product_price,
            //"unit_price": e.product_price, // comment
            "product_code": e.product_code,
            "product_name": e.product_name,
            "product_description": description,
            "product_variant_name": e.product_variant_name,
            "unit_name": e.unit_name,
            "available_stock": e.available_stock,
            "fulfillment_status_id": 1,
            "tax_amount": 0,
            "tax_name": "",
            "tax_rate": 0,
            "tax_rate_id": e.tax_rate_id ?? null,
            "fulfilled_quantity": 0,
            "discount_rate_id": e?.discount_rate_id ?? null,
            "discount_type": "",
            "discount_amount": 0,
            "discount_name": "",
            "discount_rate": "",
            "track_inventory": e.track_inventory,
            "unit_cost": e.product_cost
        }
        
        const price = parseFloat(new_item.amount);
        const quantity = parseInt(new_item.quantity);
        let totalPrice = price * quantity;
        /**
         * Compute Discount
         */
        const discount = helpers.filterObject(enums.discount_rates, e.discount_rate_id) ?? null;

        if (discount?.id) {
            const { discount_type, discount_name, discount_rate } = discount;
            const rate = parseFloat(discount_rate);
            let unitDiscount = 0;

            if (discount_type === 'percentage') {
                const normalizedRate = rate > 1 ? rate / 100 : rate;
                unitDiscount = price * normalizedRate;
            } else if (discount_type === 'fixed-rate') {
                unitDiscount = Math.min(rate, price); // prevent negative price
            }

            const unitPrice = price - unitDiscount;
            const totalDiscount = unitDiscount * quantity;
            totalPrice = unitPrice * quantity;

            Object.assign(new_item, {
                discount_type,
                discount_name,
                discount_rate,
                discount_amount: totalDiscount,
            });
        } else {
            Object.assign(new_item, {
                discount_rate_id: 0,
                discount_type: '',
                discount_name: '',
                discount_rate: '',
                discount_amount: 0,
            });
        }

        /**
         * Compute Tax
         */
        const tax = helpers.filterObject(enums.tax_rates, e.tax_rate_id) ?? null;

        if (tax?.id) {
            const taxRate = parseFloat(tax.tax_rate);
            const taxAmount = (taxRate / 100) * totalPrice;

            Object.assign(new_item, {
                tax_name: tax.tax_name,
                tax_rate: tax.tax_rate,
                tax_amount: isNaN(taxAmount) ? 0 : taxAmount,
            });
        } else {
            Object.assign(new_item, {
                tax_rate_id: 0,
                tax_name: '',
                tax_rate: '',
                tax_amount: 0,
            });
        }

        items.push(new_item)
        setRecordItems(items)
    }

    function submit(e, status = 5){
        e.preventDefault()
        //setLoading(1)

        let url = helpers.createUrl('V1/manage/quotations/create')
        if(quotation_id){
            url = helpers.createUrl('V1/manage/quotations/' + quotation_id)
        }

        let payLoad = {...form_data}
        payLoad['items'] = record_items;
        payLoad['quotation_status_id'] = status

        // if(status === 'draft'){
        //     form_data['quotation_status_id'] = 1
        //     form_data['is_draft'] = 1
        // }else{
        //     form_data['is_draft'] = 0
        // }

        httpRequest(url, 'POST', {
            postdata: payLoad,
        }, true)
            .then((res) => {
                setLoading(0)
                let id = res.data.id
                //let id = quotation_id;
                if(!id){
                    //id = res.data.id
                }

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                    allowOutsideClick: false
                })
                .then((result) => {
                    if (result.isConfirmed) {;
                        window.location.replace(`/quotations/${id}`);
                        //return;
                    }
                })
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)
                
                if(err.data){
                    setErrors( err.data );
                }else{
                    setErrors([])
                }

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }
    
    function handleModalSave(e){
        getEnums()
    }
    
    const handleAddDiscount = () => {
        dropdownRef.current?.hide();
        setShowDiscountModal(1)
    };

    const handleAddTax = () => {
        dropdownRef.current?.hide();
        setShowTaxModal(1)
    };

    const footerTemplateDiscount = () => {
        return (
            <div className='bg-light' style={{ padding: '10px', textAlign: 'center' }}>
                <button className="btn btn-primary btn-sm" type="button" onClick={handleAddDiscount}>Add New <i className="fas fa-plus-circle" /></button>
            </div>
        );
    };

    const footerTemplateTax = () => {
        return (
            <div className='bg-light' style={{ padding: '10px', textAlign: 'center' }}>
                <button className="btn btn-primary btn-sm" type="button" onClick={handleAddTax}>Add New <i className="fas fa-plus-circle" /></button>
            </div>
        );
    };

    return (
        <>
        <PaymentsListModal show_modal={payments_modal} id={quotation_id} close_modal={setPaymentsModal} />

        <ContactListModal is_show={customer_modal} setShow={setContactModal} handleSelect={handleCustomer} />

        <AddressBookModal reference_id={form_data.customer_id} is_show={address_modal} setShow={setAddressModal}  handleSelect={handleAddress} address_type={address_type} />

        {/* <ProductFinderModal 
            customer_id={form_data.customer_id} 
            is_show={product_modal} 
            setShow={setProductModal}  
            handleSelect={handleProduct} 
            exclude={record_items} 
        /> */}
        <ProductLookup 
            customer_id={form_data.customer_id} 
            is_show={product_modal} 
            setShow={setProductModal}  
            handleSelect={handleProduct} 
            exclude={record_items}
            show_bundle={true}
        />

        <TaxRateFormModal 
            show_modal={show_tax_modal} 
            close_modal={setShowTaxModal} 
            handleSave={handleModalSave}
        />

        <DiscountRateFormModal 
            show_modal={show_discount_modal} 
            close_modal={setShowDiscountModal} 
            handleSave={handleModalSave}
            defaultCurrency={default_currency}
        />

        <Layout page_title={page_title} menu="manage-quotations" breadcrumbs={true} parent_link='/quotations/list' parent_text={heading_label}>
                <div className="content">
                    <div className="container-fluid pb-5" style={{position: 'relative'}}>
                        <Loader isLoading={loading}/>
                        <form>
                            <div className="row mb-2">
                                <div quotation_id="so-customer-section" className="col-lg-12">

                                    {form_data.order_no ?
                                    <div className='border rounded p-3 mb-3 d-flex flex-column flex-md-row justify-content-between align-items-center'>
                                        <h5 className='mb-3 mb-md-0 d-flex'>{form_data.order_no}&nbsp;&nbsp;&nbsp;{helpers.displayInvoiceStatusBadge(form_data.quotation_status_id, form_data.invoice_status)}</h5>
                                        <div className='d-flex flex-column flex-sm-row'>
                                        </div>

                                        <div className='text-right'>     
                                            {
                                                (parseInt(form_data.quotation_status_id) === 1 || parseInt(form_data.quotation_status_id) == 2) 
                                                &&  (parseInt(form_data.fulfillment_status_id) === 1 || parseInt(form_data.fulfillment_status_id) === 2) 
                                                && !is_customer ?
                                                
                                                <SplitButton 
                                                    label="Save" 
                                                    buttonClassName="rounded-left border-right" 
                                                    onClick={(e) => submit(e, 2)} 
                                                    model={button_items} 
                                                    severity={"success"} 
                                                /> : ''
                                            }

                                            {
                                                //For Customer
                                                (is_customer && parseInt(form_data.quotation_status_id) === 1) && <button type='button' className='btn btn-success' onClick={(e) => submit(e, 1)} style={{padding: '0.5rem 0.75rem'}}>Save</button>
                                            }

                                            {
                                                quotation_id ? 
                                                <Link className='btn btn-outline-dark ml-3' to={`/quotations/${quotation_id}`} style={{padding: '0.5rem 0.75rem'}}>Cancel</Link>   : 
                                                <Link className='btn btn-outline-dark ml-3' to="/quotations/list" style={{padding: '0.5rem 0.75rem'}}>Cancel</Link>
                                            }
                                        </div>
                                    </div> : ''}

                                    <div className="card">

                                        <div className="card-body pt-md-5">

                                            {
                                                !is_customer &&
                                                <div className="row">
                                                    <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                        <label>Customer<span className="text-danger">*</span></label>
                                                    </div>
                                                    <div className="col-md-5 col-lg-3 form-group">
                                                        {/* <div className="input-group">
                                                            {
                                                                quotation_id ? <input type="text" className="form-control" placeholder="Select Customer" disabled={quotation_id}  value={form_data.customer_name}  /> : <input type="text" className="form-control" placeholder="Select Customer" onClick={(e) => setContactModal(1)} value={form_data.customer_name} />
                                                            }
                                                            

                                                            <div className="input-group-append">
                                                                <button className="btn btn-primary" type="button" onClick={(e) => setContactModal(1)} disabled={quotation_id}><i className="fas fa-search" /></button>
                                                            </div>
                                                        </div>        */}
                                                        <div className="p-inputgroup flex-1">
                                                            <InputText 
                                                                placeholder="Select Customer"
                                                                onClick={(e) => setContactModal(1)} 
                                                                value={form_data.customer_name} 
                                                                disabled={quotation_id ? true : false}
                                                            />
                                                            <Button 
                                                                icon="fas fa-search" 
                                                                className="p-button-primary" 
                                                                type="button"
                                                                onClick={(e) => setContactModal(1)}
                                                                disabled={quotation_id ? true : false}
                                                            />
                                                        </div>
                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="customer_name" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            <div className="row mb-3">
                                                <div className="col-md-3 col-lg-2"></div>
                                                <div className="col-md-4 col-lg-3 mb-3 mb-md-0">
                                                    <div className='border p-2 bg-light'>
                                                        <div>
                                                            <p className='mb-0'><b>{form_data.customer_name ? form_data.customer_name : ''}</b></p>
                                                            <p className='mb-0'>{form_data.billing_address ? form_data.billing_address : '---'}</p>
                                                            <p className='mb-0'>{form_data.billing_phone ? form_data.billing_phone : ''}</p>
                                                        </div>
                                                        { (parseInt(form_data.quotation_status_id) === 1 || parseInt(form_data.quotation_status_id) === 5) || (parseInt(form_data.quotation_status_id) === 2 && !is_customer) ? <button type="button" className="btn btn-primary btn-sm mt-2" onClick={(e) => viewAddressBook(2)}>Billing Address</button> : ''}
                                                    </div>
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="billing_address" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            
                                                <div className="col-md-4 col-lg-3">
                                                    <div className='border p-2 bg-light'>
                                                        <div>
                                                            <p className='mb-0'>{form_data.shipping_contact_name ? <b>{form_data.shipping_contact_name}</b>:''}</p>
                                                            <p className='mb-0'>{form_data.shipping_address ? form_data.shipping_address : '---'}</p>
                                                            <p className='mb-0'>{form_data.shipping_phone ? form_data.shipping_phone : ''}</p>
                                                        </div>
                                                        { (parseInt(form_data.quotation_status_id) === 1 || parseInt(form_data.quotation_status_id) === 5) || (parseInt(form_data.quotation_status_id) === 2 && !is_customer) ? <button type="button" className="btn btn-primary btn-sm mt-2" onClick={(e) => viewAddressBook(1)}>Shipping Address</button>: ''}
                                                    </div>
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="shipping_address" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-md-3 col-lg-2 text-left text-md-right" />
                                                <div className="col-md-5 col-lg-3 form-group">

                                                    {/* <ButtonGroupSelection
                                                        tagClass="form-control"
                                                        id="shipping_type_id"
                                                        name='shipping_type_id' 
                                                        value={form_data.shipping_type_id}  
                                                        onChange={inputChange}
                                                        onFocus=""
                                                        optionList={enums.shipping_types}
                                                        optionProps ={{value:'id', label:'shipping_type'}}
                                                        disabled = {form_data.quotation_status_id == 3 || form_data.quotation_status_id == 4 || (is_customer && form_data.quotation_status_id === 2)}
                                                    /> */}
                                                    <SelectButton 
                                                        name='shipping_type_id' 
                                                        value={parseInt(form_data.shipping_type_id)}
                                                        onChange={inputChange}
                                                        options={enums.shipping_types} 
                                                        optionLabel="shipping_type"
                                                        optionValue="id"
                                                        // disabled = {form_data.quotation_status_id == 3 || form_data.quotation_status_id == 4 || (is_customer && form_data.quotation_status_id === 2)}
                                                        disabled={parseInt(form_data.quotation_status_id) !== 1 && parseInt(form_data.quotation_status_id) !== 2}
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="shipping_type_id" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-12"><hr/></div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label>Order Date<span className="text-danger">*</span></label>
                                                </div>
                                                <div className="col-md-5 col-lg-3 form-group">
                                                    <Calendar 
                                                        name="quotation_date"  
                                                        value={form_data.quotation_date} 
                                                        onChange={inputChange} 
                                                        className='w-100' 
                                                        dateFormat="M d, yy" 
                                                        icon={() => <i className="far fa-calendar"></i>} 
                                                        showIcon  
                                                        // disabled={form_data.quotation_status_id == 3 || form_data.quotation_status_id == 4 || (parseInt(form_data.fulfillment_status_id) !== 1 && parseInt(form_data.fulfillment_status_id) !== 2) || is_customer}
                                                        
                                                        disabled={parseInt(form_data.quotation_status_id) !== 1 && parseInt(form_data.quotation_status_id) !== 2}
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="quotation_date" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                            {
                                                !is_customer &&
                                                <div className="row mb-2">
                                                    <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                        <label>Payment Terms<span className="text-danger">*</span></label>
                                                    </div>
                                                    <div className="col-md-5 col-lg-3 form-group">
                                                        <Dropdown  
                                                            name='payment_term_id'
                                                            value={parseInt(form_data.payment_term_id)} 
                                                            onChange={inputChange} 
                                                            options={enums.payment_terms} 
                                                            optionLabel="payment_term" 
                                                            optionValue="id" 
                                                            placeholder="Select Payment Terms" 
                                                            className="w-100" 
                                                            checkmark={true} 
                                                            highlightOnSelect={false}
                                                            showClear
                                                            filter 
                                                            //disabled={form_data.quotation_status_id == 3 || form_data.quotation_status_id == 4 || (parseInt(form_data.fulfillment_status_id) !== 1 && parseInt(form_data.fulfillment_status_id) !== 2) || (is_customer && form_data.quotation_status_id === 2)}
                                                            disabled={parseInt(form_data.quotation_status_id) !== 1 && parseInt(form_data.quotation_status_id) !== 2}
                                                        />
                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="payment_term_id" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                !is_customer &&
                                                <>
                                                <div className="row mb-2">
                                                    <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                        <label>Sales Channel</label>
                                                    </div>
                                                    <div className="col-md-5 col-lg-3 form-group">
                                                        <Dropdown  
                                                            name='sales_channel_id'
                                                            value={parseInt(form_data.sales_channel_id)} 
                                                            onChange={inputChange} 
                                                            options={enums.sales_channel} 
                                                            optionLabel="channel_name" 
                                                            optionValue="id" 
                                                            placeholder="Select Sales Channel" 
                                                            className="w-100" 
                                                            checkmark={true} 
                                                            highlightOnSelect={false}
                                                            showClear
                                                            filter
                                                            //disabled={form_data.quotation_status_id == 3 || form_data.quotation_status_id == 4 || (parseInt(form_data.fulfillment_status_id) !== 1 && parseInt(form_data.fulfillment_status_id) !== 2)}
                                                            disabled={parseInt(form_data.quotation_status_id) !== 1 && parseInt(form_data.quotation_status_id) !== 2}
                                                        />

                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="sales_channel_id" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                        <label>Sales Person</label>
                                                    </div>
                                                    <div className="col-md-5 col-lg-3 form-group">
                                                        <Dropdown  
                                                            name='sales_person_id'
                                                            value={parseInt(form_data.sales_person_id)} 
                                                            onChange={inputChange} 
                                                            options={enums.employees} 
                                                            optionLabel="full_name" 
                                                            optionValue="id" 
                                                            placeholder="Select Sales Personal" 
                                                            className="w-100" 
                                                            checkmark={true} 
                                                            highlightOnSelect={false}
                                                            showClear
                                                            filter
                                                            disabled={parseInt(form_data.quotation_status_id) !== 1 && parseInt(form_data.quotation_status_id) !== 2}
                                                        />

                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="sales_person_id" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div>

                                                </>
                                            }
                                            <div className="row">
                                                <div className="col-md-3 col-lg-2 text-left text-md-right mb-2">
                                                    <label className='mb-0'>Notes</label><br/>
                                                    <small>(Internal only)</small>
                                                </div>
                                                <div className="col-md-5 col-lg-3 form-group">
                                                    <InputTextarea
                                                        quotation_id="notes" 
                                                        name="notes" 
                                                        value={form_data.notes}  
                                                        className='w-100'
                                                        tagClass="form-control"
                                                        onChange={inputChange}
                                                        placeholder=""
                                                        rows={3}
                                                        disabled={parseInt(form_data.quotation_status_id) !== 1 && parseInt(form_data.quotation_status_id) !== 2}
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="notes" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                            { form_data.quotation_status_id == 4 ?
                                            <div className="row">
                                                <div className="col-md-3 col-lg-2 text-left text-md-right">
                                                    <label>Cancellation Reason</label>
                                                </div>
                                                <div className="col-md-5 col-lg-3 form-group">
                                                    <InputTextarea
                                                        value={form_data.reason}
                                                        className='w-100'  
                                                        tagClass="form-control"
                                                        onChange={inputChange}
                                                        placeholder="Optional"
                                                        rows={2}
                                                        disabled={true}
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="notes" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div> : ''}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div quotation_id="so-item-container mt-5" className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body p-0 table-responsive">
                                            <table className='table mb-0'>
                                                <thead className='thead-light'>
                                                    <tr>
                                                        <th>ITEM</th>
                                                        <th>QUANTITY</th>
                                                        <th>ITEM&nbsp;PRICE</th>
                                                        {parseInt(discount_enabled) && !is_customer ? <th>DISCOUNT</th> : ''}
                                                        {parseInt(tax_enabled) && !is_customer ? <th>TAX</th> : ''}
                                                        <th>AMOUNT</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {table_items}
                                                    {parseInt(form_data.quotation_status_id) === 1 || parseInt(form_data.quotation_status_id) === 2 ?
                                                    <tr className='bg-light'>
                                                        <td colSpan={6} className='text-center'>
                                                            <RenderErrors 
                                                                errors={errors} 
                                                                name="items" 
                                                                className="text-danger mb-2"
                                                                style={{fontSize: '.9rem'}}
                                                            />
                                                            <button type="button" className="btn btn-outline-primary" onClick={(e) => setProductModal(1)}>Add Item</button>
                                                        </td>
                                                    </tr> : ''}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-6"></div>
                                <div className="col-lg-6">
                                    <div className="card">
                                        <div className="card-body p-0">
                                            <table className="table">
                                                
                                                <tbody className='border-top-0'>
                                                    <tr>
                                                        <td className='text-right border-right border-0'>Sub Total</td>
                                                        <td className='border-0'>{computeSubTotals()}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-right border-0 pt-0'>Quantity</td>
                                                        <td className='border-0 pt-0'>{computeTotals('quantity')}</td>
                                                    </tr>
                                                    {
                                                        !is_customer &&
                                                        <tr>
                                                            <td className='text-right border-0 pt-0'>Shipping Fee ({default_currency})</td>
                                                            <td className='border-0 pt-0'>
                                                                {
                                                                    parseInt(form_data.quotation_status_id) === 3 && parseInt(form_data.quotation_status_id) === 4  ?
                                                                    helpers.formatCurrencyAmount(form_data.shipping_fee, default_currency) :
                                                                    <InputNumber
                                                                        name="shipping_fee" 
                                                                        value={form_data.shipping_fee}
                                                                        inputClassName="w-100"
                                                                        onValueChange={inputChange}
                                                                        placeholder="PHP"
                                                                        minFractionDigits={2}
                                                                        readOnly={form_data.quotation_status_id == 3 || form_data.quotation_status_id == 4}
                                                                    />
                                                                }
                                                            </td>
                                                        </tr>
                                                    }
                                                    {
                                                        discount_breakdown
                                                    }
                                                    {
                                                        tax_breakdown
                                                    }
                                                    <tr>
                                                        <td className='text-right border-right-0'><h5 className='font-weight-bold'>Total</h5></td>
                                                        <td><h5 className='font-weight-bold'>{helpers.formatCurrencyAmount(computeTotals('total'), default_currency)}</h5></td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='text-right mt-3'>     
                                {/* {
                                    !record_loaded ? <button type='button' className='btn btn-outline-dark mr-3' onClick={(e) => submit(e, 1)} style={{padding: '0.5rem 0.75rem'}}>Save as Draft</button> : ''
                                } */}

                                {/* {
                                    parseInt(form_data.quotation_status_id) === 5 ?
                                    <SplitButton 
                                        label="Save as Draft" 
                                        buttonClassName="rounded-left border-right" 
                                        onClick={(e) => submit(e, 5)} 
                                        model={button_items} 
                                        severity={"success"} 
                                    /> : ''
                                } */}

                                {
                                    (parseInt(form_data.quotation_status_id) === 1 || parseInt(form_data.quotation_status_id) === 2) && (
                                    <>

                                        {
                                            parseInt(form_data.quotation_status_id) === 1 && (
                                        <button className='btn btn-outline-success mr-3' onClick={(e) => submit(e, 1)}>
                                            Save Draft
                                        </button>)
                                        }
                                        
                                        <button className='btn btn-success' onClick={(e) => submit(e, 2)}>
                                            Save
                                        </button>
                                    </>
                                )}
                                
                                {
                                    quotation_id ? 
                                    <Link className='btn btn-outline-dark ml-3' to={`/quotations/${quotation_id}`} style={{padding: '0.5rem 0.75rem'}}>Cancel</Link>   : 
                                    <Link className='btn btn-outline-dark ml-3' to="/quotations/list" style={{padding: '0.5rem 0.75rem'}}>Cancel</Link>
                                }
                            </div>
                        </form>
                    </div>
                </div>
        </Layout>
        </>
    )
}